import { render, staticRenderFns } from "./mail-collection.vue?vue&type=template&id=7f716004&scoped=true"
import script from "./mail-collection.vue?vue&type=script&lang=ts"
export * from "./mail-collection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f716004",
  null
  
)

export default component.exports